import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo, useState } from "react";
import userIcon from "assets/img/userIcon.png";
import PopoverMenu from "./PopoverMenu";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import Tooltip from "./Tooltip";
const HeaderAccount = ({ loggedInRole, groupID }) => {
    const navigate = useNavigate();
    const { userData, logout, globalConfig } = useContext(AuthContext);
    const [open, setOpen] = useState(false);
    const isBillingDisabled = useMemo(() => {
        var _a;
        return ((_a = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.find((e) => e.key === "isBillingDisabled")) === null || _a === void 0 ? void 0 : _a.value) ===
            "true" || false;
    }, [globalConfig]);
    const options = useMemo(() => {
        return [
            {
                value: "_My_Profile",
                label: t("_My_Profile"),
                onClick: () => {
                    navigate("/app/header/change-profile");
                },
            },
            ...(loggedInRole !== "PA" && !isBillingDisabled
                ? [
                    {
                        value: "_Billing",
                        label: t("_Billing"),
                        onClick: () => {
                            navigate(`/app/header/billing`);
                        },
                    },
                ]
                : []),
            ...(loggedInRole == "EA" || loggedInRole == "EU"
                ? []
                : [
                    {
                        value: "_Settings",
                        label: t("_Settings"),
                        onClick: () => {
                            navigate(`/app/header/settings/${groupID}`);
                        },
                    },
                ]),
            {
                value: "_Log_out",
                label: t("_Log_out"),
                onClick: () => {
                    logout();
                },
            },
        ];
    }, [loggedInRole, groupID, isBillingDisabled]);
    const name = userData.name;
    return (_jsx(PopoverMenu, { options: options, offsetX: 22, contentMinWidth: "150px", className: "px-6 py-3", open: open, setOpen: setOpen, children: _jsxs("div", { className: "flex cursor-pointer relative", children: [_jsx("img", { src: (userData === null || userData === void 0 ? void 0 : userData.profileImg) || userIcon, className: "rounded-full h-9  w-10 object-cover ltr:mr-[8px] rtl:ml-[8px] select-none", alt: "user-icon" }), _jsx("h1", { className: "font-nunito my-auto ltr:mr-[31px] rtl:ml-[31px] hidden sm:inline-block font-bold", children: (name === null || name === void 0 ? void 0 : name.length) > 12 ? (_jsx(Tooltip, { content: name, disabled: open, children: _jsx("span", { children: name.substring(0, 12) + "..." }) })) : (name) })] }) }));
};
export default HeaderAccount;
